
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cancel",
      function () {
        return require("private-next-pages/cancel.tsx");
      }
    ]);
  